/** Default storefront mount positions (app embed, no theme block). */
export const DEFAULT_POSITION_BY_PLACEMENT = {
  product_page: "Below the Add to cart button on product pages",
  cart_page: "Above the cart items section on the cart page",
  home_page: "Below the header at the top of the home page",
  announcement_bar: "Fixed bar at the top of every page (full width)",
};

export function getDefaultPagesForPlacement(placementType) {
  switch (placementType) {
    case "cart_page":
      return "cart_page";
    case "announcement_bar":
      return "every_page";
    default:
      return "all_products";
  }
}

const PRODUCT_PAGE_CHOICE_VALUES = new Set([
  "all_products",
  "specific_products",
  "specific_collections",
  "specific_tags",
]);

const SITE_WIDE_PAGE_CHOICE_VALUES = new Set([
  "every_page",
  "home_only",
  "all_product_pages",
  "specific_products",
  "specific_collections",
  "all_collection_pages",
  "specific_collection_pages",
]);

/** Coerce stored pages to a valid ChoiceList value for the editor UI. */
export function normalizePlacementPages(pages, placementType) {
  const raw = pages || getDefaultPagesForPlacement(placementType);
  if (placementType === "cart_page") return "cart_page";
  if (placementType === "announcement_bar") {
    if (raw === "site_wide" || raw === "all_products") return "every_page";
    return SITE_WIDE_PAGE_CHOICE_VALUES.has(raw) ? raw : "every_page";
  }
  return PRODUCT_PAGE_CHOICE_VALUES.has(raw) ? raw : "all_products";
}

export function getDefaultPositionLabel(placementType) {
  return DEFAULT_POSITION_BY_PLACEMENT[placementType] || "Automatic theme position";
}

export function resolvePositionMode(placement) {
  const pl = placement || {};
  if (pl.position_mode === "custom" || pl.pages === "custom_position") return "custom";
  return "default";
}

export function isCustomPosition(placement) {
  return resolvePositionMode(placement) === "custom";
}
